export function windowRatio() {
  return window.innerWidth / window.innerHeight;
}

export function orientation() {
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
}

export function windowInfo() {
  return { width: window.innerWidth, height: window.innerHeight, orientation: orientation() };
}